var InMemoryStorageAdapter = (function () {
    function InMemoryStorageAdapter() {
        this.items = new Map([]);
    }
    InMemoryStorageAdapter.prototype.setItem = function (key, value) {
        try {
            this.items.set(key, value);
            return true;
        }
        catch (_a) {
            return false;
        }
    };
    InMemoryStorageAdapter.prototype.getItem = function (key) {
        var item = this.items.get(key);
        return item !== null && item !== void 0 ? item : null;
    };
    InMemoryStorageAdapter.prototype.removeItem = function (key) {
        this.items["delete"](key);
    };
    InMemoryStorageAdapter.prototype.clear = function () {
        this.items.clear();
    };
    return InMemoryStorageAdapter;
}());
export { InMemoryStorageAdapter };
var SessionStorageAdapter = (function () {
    function SessionStorageAdapter() {
    }
    SessionStorageAdapter.prototype.setItem = function (key, value) {
        try {
            window.sessionStorage.setItem(key, value);
            return true;
        }
        catch (_a) {
            return false;
        }
    };
    SessionStorageAdapter.prototype.getItem = function (key) {
        return window.sessionStorage.getItem(key);
    };
    SessionStorageAdapter.prototype.removeItem = function (key) {
        window.sessionStorage.removeItem(key);
    };
    SessionStorageAdapter.prototype.clear = function () {
        window.sessionStorage.clear();
    };
    return SessionStorageAdapter;
}());
export { SessionStorageAdapter };
//# sourceMappingURL=StorageAdapter.js.map